import React from 'react';
import {
  Container,
  Jumbotron,
} from 'reactstrap';
import AppComponent from './AppComponent';

import '../../css/Page404.css';

class Page404 extends AppComponent {
  render() {
    return (
      <Container className="page404-container text-center">
        <Jumbotron>
          <Container>
            <h1 className="display-1">404</h1>
            <p className="lead">The page you requested could not be found</p>
          </Container>
        </Jumbotron>
      </Container>
    );
  }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/components/core/Page404.js